import i18n from 'i18n';
import {getHierarchyRootLabel, isHierarchyLeafNode, SunburstTreeNode} from './aggregationsToSunburstTree';

interface TreePathInfoItem {
    name: string;
    dataIndex?: number;
    value?: number;
}

export interface HierarchyTooltipParams {
    data?: SunburstTreeNode;
    name?: string;
    value?: number;
    treePathInfo?: TreePathInfoItem[];
    treeAncestors?: TreePathInfoItem[];
}

const PATH_SEPARATOR = ' | ';

function resolveNodeName(params: HierarchyTooltipParams): string {
    const rawName = params.data?.name ?? params.name;
    if (rawName === undefined || rawName === null || rawName === '') {
        return getHierarchyRootLabel();
    }
    return rawName;
}

function formatHierarchyPath(path: string): string {
    return path.split('|').map((part) => part.trim()).filter(Boolean).join(PATH_SEPARATOR);
}

function resolveAggregationPath(params: HierarchyTooltipParams): string {
    const pathItems = params.treePathInfo ?? params.treeAncestors;
    if (pathItems && pathItems.length > 0) {
        const names = pathItems
            .map((item) => item.name?.trim())
            .filter((name): name is string => Boolean(name));

        if (names.length > 0) {
            return names.join(PATH_SEPARATOR);
        }
    }

    const node = params.data;
    if (node && isHierarchyLeafNode(node) && node.hierarchyPath) {
        return formatHierarchyPath(node.hierarchyPath);
    }

    return resolveNodeName(params);
}

function resolveNodeValue(params: HierarchyTooltipParams): number | undefined {
    if (params.data) {
        return params.data.value;
    }

    return params.value;
}

export function formatHierarchyChartTooltip(params: HierarchyTooltipParams): string {
    const node = params.data;
    const displayPath = resolveAggregationPath(params);
    const value = resolveNodeValue(params);

    if (!node || !isHierarchyLeafNode(node)) {
        return `<div><strong>${displayPath}: ${value ?? ''}</strong></div>`;
    }

    return `
        <div>
            <strong>${displayPath}: ${node.value}</strong><br/>
            ${i18n.t('share_txt.text')} ${node.share}%<br/>
            ${i18n.t('ch_total_label.text')} ${node.total}
        </div>
    `;
}
